<cu-validation-messages *ngIf="page.visible && !page.valid && workflowPageNavigationService.pageSubmitted$ | async"
                        [failedValidations]="page.failedValidations"
                        [pageIterationId]="page.pageIterationId"
                        [validationMessages]="page.config.validationMsg">
</cu-validation-messages>
